import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/authStore'

export const useLoginStore = defineStore('chamado', {

    state: () => ({
        idEmpresa: null,
        nomeFantasia: '',
        empresaManutencao: null,
        emissoraTelevisao: null,
        idColaborador: null,
        nomeColaborador: null,
        emailColaborador: null,
        administrador: null,
        liberador: null,
        loginColaborador: null,
        token: null,
        lastActivity: null
    }),

    actions: {
        setDadosChamado(dados) {
            this.idEmpresa = dados.idEmpresa
            this.nomeFantasia = dados.nomeFantasia
            this.empresaManutencao = dados.empresaManutencao
            this.emissoraTelevisao = dados.emissoraTelevisao
            this.idColaborador = dados.idColaborador
            this.nomeColaborador = dados.nomeColaborador
            this.emailColaborador = dados.emailColaborador
            this.administrador = dados.administrador
            this.liberador = dados.liberador                
            this.loginColaborador = dados.loginColaborador
            this.token = dados.token ?? ''            
        },
        
        // Método para logout manual
        logout() {
            
            // Acessa a store de auth
            const authStore = useAuthStore()
            
            // Limpa listeners
            window.removeEventListener('beforeunload', this.handleBeforeUnload)

            // Chama rotina para limpar as sessions de login
            authStore.deslogar()
        },
        getToken() {
            if (this.token && !this.token.startsWith('Bearer ')) {
                return `Bearer ${this.token}`
            }
            return this.token || ''
        },
        
        // Verificar se tem token
        hasToken() {
            return !!this.token && this.token.trim().length > 0
        },
        // Verificar se a sessão expirou
        checkSessionExpiry() {
            const SESSION_TIMEOUT = 30 * 60 * 1000 // 30 minutos
            
            if (this.lastActivity && (Date.now() - this.lastActivity > SESSION_TIMEOUT)) {
                this.logout()
                return true
            }
            return false
        }
  },
  persist: {
        
        enabled: true,

        // Especifica quais campos serão persistidos
        strategies: [
            {
                key: 'chamado-storage',
                storage: localStorage,
                paths: [
                    'idEmpresa',
                    'nomeFantasia',
                    'empresaManutencao',
                    'idColaborador',
                    'nomeColaborador',
                    'emailColaborador',
                    'administrador',
                    'liberador',
                    'loginColaborador',
                    'token',
                    'lastActivity'
                ]
            }
        ]
    }
})